import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from 'react-router-dom';
import config from "../../../config";

const Widget = () => {
    const { vendorId } = useParams();
    const [searchParams] = useSearchParams();
    const price = searchParams.get('price');
    const return_url = searchParams.get('return_url');


    const handleOnClick = () => {
        let encodedParams = btoa("vendorId=" + vendorId + "&price=" + price + "&return_url=" + return_url);
        window.parent.location.href = `${config.baseURL}/get-it-by-delivit?q=${encodedParams}`
    }

    return (
        <button onClick={() => {
            handleOnClick()
        }} style={{
            background: "#c11111",
            borderColor: "#c11111",
            height: "45px",
            fontSize: "14px",
            borderRadius: "8px",
            border: "none",
            color: "#fff",
            width: "100%"
        }}>Get it by Delvit</button>
    );
}

export default Widget